import { render, staticRenderFns } from "./Escassez.vue?vue&type=template&id=29a42b6c&scoped=true"
import script from "./Escassez.vue?vue&type=script&lang=js"
export * from "./Escassez.vue?vue&type=script&lang=js"
import style0 from "./Escassez.vue?vue&type=style&index=0&id=29a42b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a42b6c",
  null
  
)

export default component.exports